import { togglePriorityAsset } from '@/model/ltcFinancialPlanningModel';
import { AddAssetSection } from '@client/components/ltc-financial-planning/AddAssetSection';
import { PriorityAssetSelector } from '@client/components/ltc-financial-planning/PriorityAssetSelector';
import { AppState } from '@client/model/store';
import { useDispatch, useSelector } from 'react-redux';

import { StepContentProps } from '../types';

export function PrioritiesStep(props: StepContentProps) {
  const dispatch = useDispatch();
  const { selectedAssets, priorityAssets } = useSelector(
    (state: { ltcFinancialPlanning: AppState['ltcFinancialPlanning'] }) =>
      state.ltcFinancialPlanning,
  );

  const handleTogglePriority = (assetType: LtcFinancialPlanningAssetType) => {
    dispatch(togglePriorityAsset(assetType));
  };

  return (
    <div className="py-8 text-center">
      <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">
        Which assets do you want to protect most?
      </h1>
      <p className="mx-auto mt-3 max-w-2xl text-base text-gray-700">
        Select the accounts you want to shield from long-term care expenses. We'll prioritize
        protecting these in your plan.
      </p>

      <PriorityAssetSelector
        selectedAssets={selectedAssets}
        priorityAssets={priorityAssets}
        onTogglePriority={handleTogglePriority}
        className="mx-auto mt-8 max-w-3xl"
      />

      <AddAssetSection
        className="mx-auto mt-4 max-w-3xl"
        skipDetails
      />
    </div>
  );
}
